export default "__VITE_ASSET__CxKVMLXG__"